import { useState } from "react";
import { queryClient } from "@/context/query";
import { Box } from "@smartfm/ui/components/Box";
import { Button } from "@smartfm/ui/components/Button";
import { setDefaultDashboard } from "@/services/DashboardService";
import { useSnackbarContext } from "../layouts/SnackbarContext";

type Props = {
  clientId: string;
  clientName?: string;
  buildingIds: string[];
  buildingName?: string;
  defaultData?: {
    defaultClient: string;
    defaultBuildingsMap: Map<string, {
        site: string;
        default: boolean;
    }>;
  }
}

const snackbarProps = {
  title: "",
  open: true,
  autoHideDuration: 3000,
  onClose: () => {},
  style: { height: "auto", borderLeftWidth: "1px" },
};

export const DefaultBuildingButton = ({ clientId, clientName = '', buildingIds, buildingName = '', defaultData } : Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const snackbar = useSnackbarContext();

  const isEnabledDefaultBuildingToggle = buildingIds.length === 1;
  const isDefaultBuildings = defaultData?.defaultBuildingsMap?.get(clientId)?.site === buildingIds[0] && defaultData?.defaultBuildingsMap?.get(clientId)?.default;

  const handleDefaultBuildingToggle = async () => {
    try {
      setIsLoading(true);
      await setDefaultDashboard(
        clientId,
        isDefaultBuildings ? undefined : buildingIds[0],
        defaultData?.defaultClient === clientId
      );
      await queryClient.invalidateQueries({
        queryKey: ["getDefaultSiteForUser"],
      });
      snackbar.setSnack({
        ...snackbarProps,
        message: `${isDefaultBuildings ? "Removed" : "Set"} “${buildingName}” as the default building for ${clientName}`,
        severity: "success",
        anchorOrigin: {
          horizontal: "center",
          vertical: "top",
        },
      });
    } catch (error) {
      console.error("Error setting default building:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        alignSelf: "end",
        display: isEnabledDefaultBuildingToggle ? "block" : "none",
      }}
    >
      <Button
        disabled={isLoading}
        type="Secondary"
        size="Small"
        leftIcon="home"
        label={
          isDefaultBuildings
            ? "Remove as default building"
            : "Set as default building"
        }
        onClick={handleDefaultBuildingToggle}
      />
    </Box>
  )
};